import { USStateKeys } from './usStateKeys';

export const US_STATES = [
  { value: USStateKeys.AL, label: 'Alabama' },
  { value: USStateKeys.AK, label: 'Alaska' },
  { value: USStateKeys.AZ, label: 'Arizona' },
  { value: USStateKeys.AR, label: 'Arkansas' },
  { value: USStateKeys.CA, label: 'California' },
  { value: USStateKeys.CO, label: 'Colorado' },
  { value: USStateKeys.CT, label: 'Connecticut' },
  { value: USStateKeys.DE, label: 'Delaware' },
  { value: USStateKeys.DC, label: 'District of Columbia (DC)' },
  { value: USStateKeys.FL, label: 'Florida' },
  { value: USStateKeys.GA, label: 'Georgia' },
  { value: USStateKeys.HI, label: 'Hawaii' },
  { value: USStateKeys.ID, label: 'Idaho' },
  { value: USStateKeys.IL, label: 'Illinois' },
  { value: USStateKeys.IN, label: 'Indiana' },
  { value: USStateKeys.IA, label: 'Iowa' },
  { value: USStateKeys.KS, label: 'Kansas' },
  { value: USStateKeys.KY, label: 'Kentucky' },
  { value: USStateKeys.LA, label: 'Louisiana' },
  { value: USStateKeys.ME, label: 'Maine' },
  { value: USStateKeys.MD, label: 'Maryland' },
  { value: USStateKeys.MA, label: 'Massachusetts' },
  { value: USStateKeys.MI, label: 'Michigan' },
  { value: USStateKeys.MN, label: 'Minnesota' },
  { value: USStateKeys.MS, label: 'Mississippi' },
  { value: USStateKeys.MO, label: 'Missouri' },
  { value: USStateKeys.MT, label: 'Montana' },
  { value: USStateKeys.NE, label: 'Nebraska' },
  { value: USStateKeys.NV, label: 'Nevada' },
  { value: USStateKeys.NH, label: 'New Hampshire' },
  { value: USStateKeys.NJ, label: 'New Jersey' },
  { value: USStateKeys.NM, label: 'New Mexico' },
  { value: USStateKeys.NY, label: 'New York' },
  { value: USStateKeys.NC, label: 'North Carolina' },
  { value: USStateKeys.ND, label: 'North Dakota' },
  { value: USStateKeys.OH, label: 'Ohio' },
  { value: USStateKeys.OK, label: 'Oklahoma' },
  { value: USStateKeys.OR, label: 'Oregon' },
  { value: USStateKeys.PA, label: 'Pennsylvania' },
  { value: USStateKeys.RI, label: 'Rhode Island' },
  { value: USStateKeys.SC, label: 'South Carolina' },
  { value: USStateKeys.SD, label: 'South Dakota' },
  { value: USStateKeys.TN, label: 'Tennessee' },
  { value: USStateKeys.TX, label: 'Texas' },
  { value: USStateKeys.UT, label: 'Utah' },
  { value: USStateKeys.VT, label: 'Vermont' },
  { value: USStateKeys.VA, label: 'Virginia' },
  { value: USStateKeys.WA, label: 'Washington' },
  { value: USStateKeys.WV, label: 'West Virginia' },
  { value: USStateKeys.WI, label: 'Wisconsin' },
  { value: USStateKeys.WY, label: 'Wyoming' }
];
